type Tone = "ok" | "warn" | "err" | "info" | "muted";

const TONE_CLS: Record<Tone, string> = {
  ok: "bg-emerald-500/10 text-emerald-300 border-emerald-500/30",
  warn: "bg-amber-500/10 text-amber-300 border-amber-500/30",
  err: "bg-red-500/10 text-red-300 border-red-500/30",
  info: "bg-sky-500/10 text-sky-300 border-sky-500/30",
  muted: "bg-zinc-700/30 text-zinc-400 border-zinc-700/50",
};

export function StatusBadge({
  label,
  tone = "muted",
  mono = true,
}: {
  label: string;
  tone?: Tone;
  mono?: boolean;
}) {
  return (
    <span
      className={`inline-flex items-center gap-1.5 px-2 py-0.5 text-[11px] border rounded ${
        TONE_CLS[tone]
      } ${mono ? "font-mono" : ""}`}
    >
      <span
        className={`h-1.5 w-1.5 rounded-full ${
          tone === "ok"
            ? "bg-emerald-400"
            : tone === "warn"
              ? "bg-amber-400"
              : tone === "err"
                ? "bg-red-400"
                : tone === "info"
                  ? "bg-sky-400"
                  : "bg-zinc-500"
        }`}
      />
      {label}
    </span>
  );
}
